export default {
	// actions
	actionsText: {
		view: "Ver",
		edit: "Editar",
		delete: "Eliminar",
		"*": "Acciones"
	},

	// per page
	perPageText: "Mostrando :entries datos",

	// entries info
	infoText: "Mostrando :first hasta :last de :total datos",
	infoTextFiltered:
		"Mostrando :first hasta :last de :filtered (filtrado de :total datos)",

	// pagination
	nextButtonText: "Siguiente",
	previousButtonText: "Anterior",
	paginationSearchText: "Ir a la página",
	paginationSearchButtonText: "IR",

	// search filter
	searchText: "buscar:",
	emptyTableText: "No se encontraron datos que coincidan con la búsqueda",

	// download
	downloadText: "exportar cómo:",
	downloadButtonText: "DESCARGAR"
};
